import React, { Component } from "react";
import { PageHeader } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faYoutube } from "@fortawesome/free-brands-svg-icons"
import { getMeasureTitle }          from "../../utils/Measure";
import { freeform_id }              from "../../utils/Constants";
import LoaderButton                 from "../../components/LoaderButton";
import ModalPostWorkoutSurvey       from "../../components/modal/ModalPostWorkoutSurvey";
import uniqueId                     from 'lodash/uniqueId';
import { Colors }                   from "../../utils/Colors";
import { WhiteLabel }               from "../../utils/WhiteLabelProps";
import { invokeGetAthleteExerciseHistory,
         invokeGetProgramWorkoutDates,
         invokeGetWorkoutFinished } from "../../utils/AwsInvoke";

import "../../css/workout/WorkoutFinished.css";

var white_label = WhiteLabel();
const MainColor = white_label.company_primary_btn_color;
const REACT_APP_PRIMARY_COLOR = sessionStorage.getItem('primary_color');
const AWSUrl                    = white_label.aws_athlete_assets_url;
const posture_health_company_id = "69c4ac91-69b7-11ea-b027-a3b6eeba595f";

export default class WorkoutFinished extends Component {
    constructor(props) {
        super(props);

        // Breaking up WEEK and DAY in case we need to get a program's day_id
        // for duplicating a day's data from an athlete marketplace's program
        var week_day = `${this.props.match.params.week_tracker}`;
        var week = week_day.substring(0, 1);
        var day = week_day.substring(2, 3);

        var curr_week_day = "Week " + week + ", Day " + day;

        var globalUserCompanyId = localStorage.getItem('globalUserCompanyId');

        this.state = {
            title:        `${this.props.match.params.title}`,
            program_id:   `${this.props.match.params.program_id}`,
            week_tracker:  curr_week_day, //`${this.props.match.params.week_tracker}`,
            day_id:       `${this.props.match.params.day_id}`,
            company_id:    globalUserCompanyId,
            activeKey:     1,
            isLoading:     true,
            workout_start_time: 0,
            survey_submitted_txt: "",
            showModalPostWorkoutSurvey: false,
            list: []
        };
    }

    async componentDidMount() {

        if (!this.props.isAuthenticated)
            return;

        try {
            this.renderFinished();
        } catch (e) {
            alert(e);
        }

        this.setState({ isLoading: false });
    }


    async renderFinished() {
        var day_id      = this.state.day_id;
        var program_id  = this.state.program_id;
        var results    = await invokeGetWorkoutFinished(program_id, day_id);

        if(results.status) {
            var results2  = await invokeGetProgramWorkoutDates(program_id);

            if(results2.status) {
                this.setState({
                    workout_start_time: results.data.workout_day_start_time[0].date_created
                })
            }
        }
    }

    renderProgramsList() {

        var exercise_data = this.renderWorkoutList();

        var programs = <span className="workoutDetailsContainer" >
                                <span className="">
                                     { exercise_data }
                                </span>
                        </span>

        return programs;
    }

    renderList() {
        return (
            <div className="list">
                {!this.state.isLoading && this.renderProgramsList()}
            </div>
        );
    }

    renderSetList() {
        var programs = [];
        var list   = this.state.list;
        var blocks = "";//this.state.block_ids;


        var workout = <span style={{display: "inline-block", width: "100%"}}></span>
        return workout;
    }

    handleGoBackPage = () => {
        this.props.history.goBack();
    }

    handlePostWorkoutSurvey = () => {
            this.setState({ showModalPostWorkoutSurvey: true })
    }

    renderWorkoutList() {
        var list = this.state.list;
        var exercise_arr = [];
        var title        = this.state.title;
        var program_id   = this.state.program_id;
        var image = this.renderPlaceholderImage("Exercise History");

        ////  Get Date/Time Difference between workout begin and end  ////
        var date = new Date()
        var start_time = this.state.workout_start_time;
        var end_time = date.toISOString();
        var d1 = new Date(start_time),
            d2 = new Date(end_time);
        var diff = d2 - d1;
        /*var hours = Math.floor(diff / 60e3) / 60;
        var minutes = (hours*60)-diff;
        var total_minutes = hours + " hour " + minutes + " minutes";*/
        var mins = Math.floor(diff / 60e3);
        var m_lgth = mins.toString().length;

        if(m_lgth > 3) mins = "--"

        var total_minutes = mins + " minutes";
        //var total_seconds = Math.floor(diff / 1e3);

        var border_top    = "5px solid #ccc";
        var confirm_label = this.state.survey_submitted_txt;
        var mktplc_id     = localStorage.getItem('athleteMarketplaceId');

        var post_workout_survey = <span className="surveyPostWorkoutContainer"
                                          onClick={this.handlePostWorkoutSurvey}>
                                        <span className="surveyPostWorkoutIcon"
                                              onClick={this.handlePostWorkoutSurvey}
                                              alt="Post-Workout Survey" >
                                            <FontAwesomeIcon icon="clipboard-check" className="iconPostWorkoutSurvey" style={{color: MainColor}}/>
                                            <span className="surveyPostWorkoutIconText">survey*</span>
                                        </span>
                                    </span>
        if(this.state.company_id == posture_health_company_id)
            post_workout_survey = "";

        return (
            <span className="workoutDetailsSummar">
                    { image }
                    <div>
                        <div className="workoutDetailsHistoryRow" style={{borderTop: border_top}}>
                            <span className="workoutDetailsDayViewLabel"
                                  onClick={this.handleGoBackPage}>
                                {/*}<span className="goBackDayViewGlyphIcon">
                                    <span className="glyphicon glyphicon-menu-left"/>
                                </span>*/ }
                            </span>
                        </div>
                        <span className="workoutDetilsBodyPadding">
                                <span>
                                </span>
                                <div className="workoutFinishedMessage"
                                     style={{position:"relative", textAlign: "center"}}
                                >
                                    <FontAwesomeIcon icon="check-circle" className="" style={{ width: "100%", position:"relative", top:"15px", fontSize: 100, color:MainColor }}/>
                                    <br/><br/>
                                    <span style={{color: REACT_APP_PRIMARY_COLOR}}>
                                        Congrats, your workout is finished!
                                    </span>
                                    <br/><br/>
                                <div style={{position:"relative", top:"-25px"}}>
                                        <FontAwesomeIcon icon="clock" className="" style={{ position:"relative", top:"3px", color:"#999", paddingRight:6, fontSize:32 }}/>
                                        <span style={{color: "#666"}}>
                                            Workout Time
                                        </span>
                                        <div style={{color: "#000"}}>
                                                { total_minutes }
                                        </div>
                                    </div>
                                    <div style={{position:"relative", top:"-8px", fontSize: 16}}>
                                                <FontAwesomeIcon icon="award" className="" style={{width: "100%", fontSize: 40, color: "#999" }}/>
                                                <span style={{position:"relative", top:5,color: "#000"}}>
                                                    You earned +10 fitness points!
                                                </span>
                                    </div>
                                    <div style={{fontSize:20, color:Colors.ok_button_bg}}>{ confirm_label }</div>
                                    <br/>
                                    { post_workout_survey }

                                    <br/>
                                    { /* Program Completed: 30%<br/><br/>*/ }
                                    <span className="programBeginExerciseTitle"
                                          style={{position:"relative", top:"-22px"}}
                                          href={`/programBegin/${program_id}/${title}/${mktplc_id}`}
                                          onClick={this.handleSubmitClick}
                                    >
                                        <LoaderButton
                                            bsSize   = "large"
                                            width    = "285px"
                                            height   = "40px"
                                            fontSize = "20px"
                                            btncolor = { Colors.medium_gray }
                                            type     = "submit"
                                            isLoading= {this.state.isLoading}
                                            text     = "Back to Program"
                                            loadingText="Logging in…"
                                          />

                                      <br/><br/>
                                      <div style={{fontSize:11, color: "#666"}}>* Fill out the survey after you complete your workout</div>
                                    </span>
                                </div>
                                <div>


                                </div>
                        </span>
                    </div>
            </span>
        );
    }

    handleSubmitClick = event => {
      event.preventDefault();
      this.props.history.push(event.currentTarget.getAttribute("href"));
    }

    onSurveyComplete = () => {
        this.setState({
            survey_submitted_txt: "Thx, the survey was submitted.",
            showModalPostWorkoutSurvey: false
        })
    }

    renderPlaceholderImage = (name) => {
        var title        = this.state.title;
        var week_tracker = this.state.week_tracker;
        var program_id   = this.state.program_id;
        var image2;

        var cover_image = localStorage.getItem('coverImage');

        if(cover_image != undefined)
            image2 = <img src={ cover_image } width="100%"/> //require(`../../images/program_categories/`+image)

        //else if(image != undefined)
        //    image2 = <img src={require(`../../images/program_categories/`+image)} width="100%"/>

        return  (<span>
                        <span className="programBeginImage">
                            { image2 }
                        </span>
                        <span className="programWorkoutFinishedFadeImage">
                            <img src={require('../../images/utils/program_category_black_fade2.png')} style={{opacity: .7}} height="75" width="100%"/>
                        </span>
                        <span className="programWorkoutTitle"
                                  href={`/ProgramBegin/${program_id}/${title}`}
                                  onClick={this.handleWorkoutDetails}
                                  style={{whiteSpace: "nowrap", overflowX:"hidden", color: "#fff"}}
                                  >
                                  {title}
                        </span>
                        <span className="programWorkoutDateTitle"
                              style={{position:"absolute", top:57, left:0, fontSize:"24px", color: "#fff"}}
                              >
                              {week_tracker}
                        </span>
                        <span className="programWorkoutFreeformTitle" style={{color:"black"}}></span>
                        <span style={{display:"block",height:80}}/>
                 </span>)
    }

    render() {
        let closeModalPostWorkoutSurvey = () => this.setState({ showModalPostWorkoutSurvey: false }); //close simple modal window

        return (
            <div className="HomeProgramWorkoutDetails">

              {this.renderList()}

              {this.state.showModalPostWorkoutSurvey ?
                  <ModalPostWorkoutSurvey
                      show          = { this.state.showModalPostWorkoutSurvey}
                      onHide        = { closeModalPostWorkoutSurvey}
                      onSurveyComplete = { this.onSurveyComplete }
                      program_id    = { this.state.program_id }
                      day_id        = { this.state.day_id  }
                  />
              : null}

              { /*this.props.isAuthenticated ? this.renderNotes() : this.renderLander()*/ }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/workout/WorkoutFinished.js